import { Validator } from "../validator"

export enum JobTitleError {
    BLANK = `invalid_input`,
}

class JobTitleValidator implements Validator<string, JobTitleError> {
    validate(entry: string): JobTitleError | undefined {
        if (entry === ``) {
            return JobTitleError.BLANK
        }
    }
}
export { JobTitleValidator }